export const ACTION__SIM_SPEED__STOP = 'sim-stop';
export const ACTION__SIM_SPEED__START = 'sim-start';
export const ACTION__SIM_SPEED__ONE = 'sim-speed-1';
export const ACTION__SIM_SPEED__TWO = 'sim-speed-2';
export const ACTION__SIM_SPEED__FIVE = 'sim-speed-5';
export const ACTION__SIM_SPEED__TEN = 'sim-speed-10';

export const ACTION__SETTLEMENT__BUILD_LUMBERJACK = 'build-lumberjack';
export const ACTION__SETTLEMENT__HIRE_LUMBERJACK = 'hire-lumberjack';
export const ACTION__SETTLEMENT__FIRE_LUMBERJACK = 'fire-lumberjack';
export const ACTION__SETTLEMENT__HIRE_ASSISTANT = 'hire-assistant';
export const ACTION__SETTLEMENT__FIRE_ASSISTANT = 'fire-assistant';
export const ACTION__SETTLEMENT__BUILD_SAWMILL = 'build-sawmill';
export const ACTION__SETTLEMENT__HIRE_SAWMILLER = 'hire-sawmiller';
export const ACTION__SETTLEMENT__FIRE_SAWMILLER = 'fire-sawmiller';
export const ACTION__SETTLEMENT__HIRE_BUILDER = 'hire-builder';
export const ACTION__SETTLEMENT__FIRE_BUILDER = 'fire-builder';
export const ACTION__SETTLEMENT__SET_HOUSE_FOOD_TARGET = 'set-house-food-target';
export const ACTION__SETTLEMENT__SET_HOUSE_HEAT_TARGET = 'set-house-heat-target';
export const ACTION__SETTLEMENT__SET_BLACKSMITH_TOOL_TARGET = 'set-blacksmith-tool-target';
export const ACTION__SETTLEMENT__SET_BLACKSMITH_WEAPON_TARGET = 'set-blacksmith-weapon-target';
export const ACTION__SETTLEMENT__OPEN_PRODUCTION_PREFIX = 'open-production:';
export const ACTION__SETTLEMENT__SET_PRODUCTION_CAP_PREFIX = 'set-production-cap:';
export const ACTION__SETTLEMENT__SELECT_HOUSE_PREFIX = 'select-house:';
export const ACTION__SETTLEMENT__CANCEL_CONSTRUCTION_PREFIX = 'cancel-construction:';
export const ACTION__SETTLEMENT__BUILD_HOUSE = 'build-house';
export const ACTION__SETTLEMENT__BUILD_STONE_HOUSE = 'build-stone-house';
export const ACTION__SETTLEMENT__BUILD_FARM = 'build-farm';
export const ACTION__SETTLEMENT__BUILD_HUNTING_HUT = 'build-hunting-hut';
export const ACTION__SETTLEMENT__BUILD_FISHING_HUT = 'build-fishing-hut';
export const ACTION__SETTLEMENT__BUILD_SMOKEHOUSE = 'build-smokehouse';
export const ACTION__SETTLEMENT__BUILD_WEAVER = 'build-weaver';
export const ACTION__SETTLEMENT__BUILD_BLACKSMITH = 'build-blacksmith';
export const ACTION__SETTLEMENT__BUILD_GOLD_MINE = 'build-gold-mine';
export const ACTION__SETTLEMENT__BUILD_MINT = 'build-mint';
export const ACTION__SETTLEMENT__BUILD_CARAVAN_POST = 'build-caravan-post';
export const ACTION__SETTLEMENT__BUILD_STABLE = 'build-stable';
export const ACTION__SETTLEMENT__BUILD_QUARRY = 'build-quarry';
export const ACTION__SETTLEMENT__BUILD_MASONRY = 'build-masonry';
export const ACTION__SETTLEMENT__BUILD_CHARCOAL_PIT = 'build-charcoal-pit';
export const ACTION__SETTLEMENT__BUILD_IRON_MINE = 'build-iron-mine';
export const ACTION__SETTLEMENT__BUILD_SMELTER = 'build-smelter';
export const ACTION__SETTLEMENT__BUILD_BARRACKS = 'build-barracks';
export const ACTION__SETTLEMENT__HIRE_FORESTER = 'hire-forester';
export const ACTION__SETTLEMENT__FIRE_FORESTER = 'fire-forester';
export const ACTION__SETTLEMENT__HIRE_FARMER = 'hire-farmer';
export const ACTION__SETTLEMENT__FIRE_FARMER = 'fire-farmer';
export const ACTION__SETTLEMENT__HIRE_HUNTER = 'hire-hunter';
export const ACTION__SETTLEMENT__FIRE_HUNTER = 'fire-hunter';
export const ACTION__SETTLEMENT__HIRE_FISHER = 'hire-fisher';
export const ACTION__SETTLEMENT__FIRE_FISHER = 'fire-fisher';
export const ACTION__SETTLEMENT__HIRE_SMOKER = 'hire-smoker';
export const ACTION__SETTLEMENT__FIRE_SMOKER = 'fire-smoker';
export const ACTION__SETTLEMENT__HIRE_WEAVER = 'hire-weaver';
export const ACTION__SETTLEMENT__FIRE_WEAVER = 'fire-weaver';
export const ACTION__SETTLEMENT__HIRE_SMITH = 'hire-smith';
export const ACTION__SETTLEMENT__FIRE_SMITH = 'fire-smith';
export const ACTION__SETTLEMENT__HIRE_GOLD_MINER = 'hire-gold-miner';
export const ACTION__SETTLEMENT__FIRE_GOLD_MINER = 'fire-gold-miner';
export const ACTION__SETTLEMENT__HIRE_MINTER = 'hire-minter';
export const ACTION__SETTLEMENT__FIRE_MINTER = 'fire-minter';
export const ACTION__SETTLEMENT__HIRE_QUARRYMAN = 'hire-quarryman';
export const ACTION__SETTLEMENT__FIRE_QUARRYMAN = 'fire-quarryman';
export const ACTION__SETTLEMENT__HIRE_MASON = 'hire-mason';
export const ACTION__SETTLEMENT__FIRE_MASON = 'fire-mason';
export const ACTION__SETTLEMENT__HIRE_BURNER = 'hire-burner';
export const ACTION__SETTLEMENT__FIRE_BURNER = 'fire-burner';
export const ACTION__SETTLEMENT__HIRE_MINER = 'hire-miner';
export const ACTION__SETTLEMENT__FIRE_MINER = 'fire-miner';
export const ACTION__SETTLEMENT__HIRE_SMELTER = 'hire-smelter';
export const ACTION__SETTLEMENT__FIRE_SMELTER = 'fire-smelter';
export const ACTION__SETTLEMENT__HIRE_MILITIA = 'hire-militia';
export const ACTION__SETTLEMENT__FIRE_MILITIA = 'fire-militia';

export const ACTION__UI__OPEN_SETTINGS = 'open-settings';
export const ACTION__UI__LANGUAGE__EN = 'language-en';
export const ACTION__UI__LANGUAGE__PL = 'language-pl';
export const ACTION__UI__DISMISS_NOTIFICATION = 'dismiss-notification';
export const ACTION__UI__DISMISS_ALERT = 'dismiss-alert';
export const ACTION__UI__TOGGLE_NOTIFICATIONS = 'toggle-notifications';
export const ACTION__UI__TOGGLE_SPEED_MENU = 'toggle-speed-menu';
export const ACTION__UI__TOGGLE_LANGUAGE_MENU = 'toggle-language-menu';
export const ACTION__UI__OPEN_BATTLE_REPORT = 'open-battle-report';
export const ACTION__UI__OPEN_SCOUTING_MISSION = 'open-scouting-mission';
export const ACTION__SETTINGS__SAVE = 'settings-save';
export const ACTION__SETTINGS__RESET = 'settings-reset';
export const ACTION__SETTINGS__TAB__CONFIG = 'settings-tab-config';
export const ACTION__SETTINGS__TAB__AUDIO = 'settings-tab-audio';
export const ACTION__SETTINGS__AUDIO__TOGGLE_BACKGROUND = 'settings-audio-toggle-background';
export const ACTION__SETTINGS__AUDIO__TOGGLE_BELL = 'settings-audio-toggle-bell';
export const ACTION__SETTINGS__AUDIO__TOGGLE_HIT = 'settings-audio-toggle-hit';
export const ACTION__SETTINGS__AUDIO__SET_BACKGROUND_VOLUME =
    'settings-audio-set-background-volume';
export const ACTION__SETTINGS__AUDIO__SET_BELL_VOLUME = 'settings-audio-set-bell-volume';
export const ACTION__SETTINGS__AUDIO__SET_HIT_VOLUME = 'settings-audio-set-hit-volume';

export const ACTION__TILE__FOUND_SETTLEMENT = 'tile-found-settlement';
export const ACTION__TILE__OPEN_FOUNDING = 'tile-open-founding';
export const ACTION__TILE__OPEN_SCOUT = 'tile-open-scout';
export const ACTION__TILE__RETURN_TROOPS = 'tile-return-troops';
export const ACTION__TILE__ASSIGN_SCOUT_TARGET = 'tile-assign-scout-target';

export const ACTION__SCOUT__UNIT = 'scout-unit';
export const ACTION__SCOUT__FOOD = 'scout-food';
export const ACTION__SCOUT__CONFIRM = 'scout-confirm';
export const ACTION__SCOUT__PLAN_ALTER = 'scout-plan-alter';
export const ACTION__SCOUT__PLAN_CLEAR = 'scout-plan-clear';
export const ACTION__SCOUT__RETURN = 'scout-return';

export const ACTION__FOUNDING__UNIT = 'founding-unit';
export const ACTION__FOUNDING__FOOD = 'founding-food';
export const ACTION__FOUNDING__RESOURCE = 'founding-resource';
export const ACTION__FOUNDING__CONFIRM = 'founding-confirm';

export const ACTION__MODAL__TAB__BUILDINGS = 'tab-buildings';
export const ACTION__MODAL__TAB__BUILDINGS__CORE = 'tab-buildings-core';
export const ACTION__MODAL__TAB__BUILDINGS__FOOD = 'tab-buildings-food';
export const ACTION__MODAL__TAB__BUILDINGS__INDUSTRY = 'tab-buildings-industry';
export const ACTION__MODAL__TAB__BUILDINGS__MINING = 'tab-buildings-mining';
export const ACTION__MODAL__TAB__BUILDINGS__CRAFT = 'tab-buildings-craft';
export const ACTION__MODAL__TAB__BUILDINGS__SUPPORT = 'tab-buildings-support';
export const ACTION__MODAL__TAB__JOBS = 'tab-jobs';
export const ACTION__MODAL__TAB__JOBS__CORE = 'tab-jobs-core';
export const ACTION__MODAL__TAB__JOBS__FOOD = 'tab-jobs-food';
export const ACTION__MODAL__TAB__JOBS__INDUSTRY = 'tab-jobs-industry';
export const ACTION__MODAL__TAB__JOBS__MINING = 'tab-jobs-mining';
export const ACTION__MODAL__TAB__JOBS__CRAFT = 'tab-jobs-craft';
export const ACTION__MODAL__TAB__JOBS__SUPPORT = 'tab-jobs-support';
export const ACTION__MODAL__TAB__PRODUCTION = 'tab-production';
export const ACTION__MODAL__TAB__LOG = 'tab-log';
export const ACTION__MODAL__TAB__FOREST = 'tab-forest';
export const ACTION__MODAL__TAB__NATURE = 'tab-nature';
export const ACTION__MODAL__TAB__WILDLIFE = 'tab-wildlife';
export const ACTION__MODAL__TAB__TOOLS = 'tab-tools';
export const ACTION__MODAL__TAB__STORAGE = 'tab-storage';
export const ACTION__MODAL__TAB__ASSISTANTS = 'tab-assistants';
export const ACTION__MODAL__TAB__POPULATION = 'tab-population';
export const ACTION__MODAL__TAB__TILE__SUMMARY = 'tab-tile-summary';
export const ACTION__MODAL__TAB__TILE__SETTLEMENT = 'tab-tile-settlement';
export const ACTION__MODAL__TAB__TILE__RAW = 'tab-tile-raw';
export const ACTION__MODAL__TAB__TILE__ENEMIES = 'tab-tile-enemies';
